var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4929",
    "data-name": "Rectangle 4929",
    width: 7.096,
    height: 7.085,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13259",
    "data-name": "Group 13259",
    transform: "translate(-72 -765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_625",
    "data-name": "Ellipse 625",
    transform: "translate(72 765)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12678",
    "data-name": "Group 12678",
    transform: "translate(83.042 768.952) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12675",
    "data-name": "Group 12675",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45331",
    "data-name": "Path 45331",
    d: "M1.583,1.851c.234,0,.469,0,.7,0a.455.455,0,0,1,.484.49.441.441,0,0,1-.416.422q-.94.009-1.88,0a.494.494,0,0,1-.458-.412A.876.876,0,0,1,0,2.208C0,1.64,0,1.071,0,.5A.455.455,0,0,1,.521.008a.442.442,0,0,1,.4.427c.006.226,0,.453,0,.711.048-.042.08-.065.107-.093A3.544,3.544,0,1,1,4.232,7.017,3.459,3.459,0,0,1,.743,5.709a.46.46,0,1,1,.718-.571A2.624,2.624,0,0,0,6.154,3.827,2.607,2.607,0,0,0,3.824.94a2.587,2.587,0,0,0-2.249.867l.008.045",
    transform: "translate(-0.001 0)",
    fill: "#ef7b13"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreIcon);
export default __webpack_public_path__ + "static/media/restore_icon.b2de7f8148deb0a3b8b4675220e710ad.svg";
export { ForwardRef as ReactComponent };